export default "__VITE_ASSET__IcHBjLQr__"